import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export default {
  name: "myTimetable",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: true,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      teacherName: "",
      periodName: "",
      slots: [],
    };
  },

  computed: {
    days() {
      const uniqueDays = [...new Set(this.slots.map(slot => slot.day).filter(Boolean))];
      return uniqueDays.sort((a, b) => {
        const aIndex = DAY_ORDER.findIndex(day => day.toLowerCase() === String(a).toLowerCase());
        const bIndex = DAY_ORDER.findIndex(day => day.toLowerCase() === String(b).toLowerCase());
        return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
      });
    },
    times() {
      const uniqueTimes = [...new Set(this.slots.map(slot => slot.time).filter(Boolean))];
      return uniqueTimes.sort((a, b) => this.parseTime(a) - this.parseTime(b));
    },
    slotMap() {
      const timetableMap = {};
      this.slots.forEach(slot => {
        const key = `${slot.day}${slot.time}`;
        if (!timetableMap[key]) {
          timetableMap[key] = [];
        }
        timetableMap[key].push({
          subject_name: slot.subject_name,
          class_name: this.formatClassName(slot),
        });
      });
      return timetableMap;
    },
  },

  methods: {
    /**
     * Load the logged-in teacher's assigned slots from teacher.mobileTimetable.
     */
    getMyTimetable() {
      this.isLoading = true;
      axios.get("teacher/timetable", {
        params: {
          campus_id: this.$store.state.user.campus_id,
        },
      })
        .then(response => {
          const slots = Array.isArray(response.data) ? response.data : [];
          this.slots = slots;
          this.teacherName = this.$store.state.user.name || "";
          this.periodName = slots.length ? (slots[0].academic_year || "") : "";
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error("My Timetable Error:", error.response?.data || error.message);
          }
          this.isLoading = false;
        });
    },

    /**
     * Build class label from grade and section.
     *
     * @param {Object} slot
     * @returns {string}
     */
    formatClassName(slot) {
      const gradeName = slot.grade_name || "";
      const section = slot.section || "";
      if (gradeName && section) {
        return `${gradeName} (${section})`;
      }
      return gradeName || section;
    },

    /**
     * Sort key for a time range string such as "8:00 AM~8:45 AM".
     *
     * @param {string} value
     * @returns {number}
     */
    parseTime(value) {
      const start = String(value || "").split("~")[0].trim();
      const parsed = Date.parse(`1970-01-01 ${start}`);
      return isNaN(parsed) ? 0 : parsed;
    },
  },

  mounted() {
    this.getMyTimetable();
  },
};
